/*
 * The texts of the map extension, merged into the lib's own through its js/extension.ts.
 */
export default {
	buttons: {
		map: {
			show: 'Show on map',
			route: 'Plan route',
			locate: 'Detect location',
			clear: 'Clear location',
			zoom_in: 'Zoom in',
			zoom_out: 'Zoom out',
			north: 'Align to north',
			fit: 'Show everything',
			entities_smaller: 'Shrink symbols',
			entities_bigger: 'Enlarge symbols',
			layers: 'Layers',
			color: 'Show in color',
			grayscale: 'Show in grayscale',
			save: 'Save map',
			upload: 'Upload map',
			calculate: 'Calculate transformation',
			layer_create: 'Create layer',
			layer_edit: 'Edit layer',
			layer_delete: 'Delete layer',
			layer_detail: 'Add level of detail',
			layer_zoom: 'Zoom to layer',
			overlay_create: 'Create overlay',
			overlay_edit: 'Edit overlay',
			overlay_delete: 'Delete overlay',
			marker_create: 'Create marker',
			marker_edit: 'Edit marker',
			marker_delete: 'Delete marker',
		},
	},
	pages: {
		map: {
			context_menu: {
				center: 'Center here',
				copy_coordinates: 'Copy coordinates',
			},
		},
	},
	sidebar: {
		map: 'Map',
	},
	modals: {
		edit_event_layer: {
			create: 'Create new layer',
			edit: 'Edit layer',
		},
		edit_event_overlay: {
			create: 'Create new overlay',
			edit: 'Edit overlay',
		},
		remove_event_layer: {
			title: 'Delete map layer',
			text: "Do you really want to delete the map layer '{item}'?",
		},
		edit_marker: {
			create: 'Create new marker',
			edit: 'Edit marker',
		},
		remove_marker: {
			title: 'Delete marker',
			text: "Do you really want to delete the marker '{item}'?",
		},
	},
	confirms: {
		remove_event_overlay: {
			title: 'Delete overlay',
			text: 'Do you really want to remove the overlay "{name}"?',
		},
	},
	data: {
		event_layer: {
			name: 'Name',
			opacity: 'Opacity',
			is_grayscale: 'Grayscale',
			transformation: {
				a0: 'a0',
				b0: 'b0',
				a1: 'a1',
				b1: 'b1',
				a2: 'a2',
				b2: 'b2',
			},
		},
		event_overlay: {
			id: 'Id',
			name: 'Name',
			icon: 'Icon',
			url: 'Url',
			layer: 'Layer',
			format: 'Format',
			opacity: 'Opacity',
			minZoom: 'Zoom factor',
		},
		marker: {
			id: 'Id',
			name: 'Name',
			icon: 'Icon',
			coordinates: 'Coordinates',
			description: 'Description',
		},
	},
	enums: {
		crs: {
			'null': '-',
			'EPSG:4326': 'WGS84 (GPS)',
			'EPSG:3857': 'Web Mercator',
			'EPSG:25832': 'UTM zone 32N',
			'EPSG:25833': 'UTM zone 33N',
		},
	},
	tabs: {
		context_settings: {
			groups: {
				map: 'Map',
			},
			map: 'Map',
			markers: 'Markers',
		},
		event_settings: {
			map: 'Map',
			markers: 'Markers',
		},
	},
};
